export const COLORS = {
  // DARK THEME BASE
  background: "#0A0B0F", // Deep dark blue-black
  backgroundSecondary: "#12141A", // Slightly lighter dark
  backgroundCard: "#1A1D26", // Card backgrounds
  backgroundModal: "#1F2329", // Modal backgrounds
  
  // TEXT COLORS
  textPrimary: "#FFFFFF", // Pure white for main text
  textSecondary: "#B8BCC8", // Light gray for secondary text
  textMuted: "#6B7280", // Muted gray for captions
  textDanger: "#FF4757", // Red for urgent text
  
  // ACCENT COLORS - High contrast for dark theme
  primary: "#3B82F6", // Bright blue
  secondary: "#EF4444", // Bright red for urgency
  success: "#10B981", // Bright green for success
  warning: "#F59E0B", // Bright orange for warnings
  
  // GRADIENT COLORS - For popping effects
  gradientPrimary: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
  gradientSecondary: "linear-gradient(135deg, #f093fb 0%, #f5576c 100%)",
  gradientSuccess: "linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)",
  gradientDanger: "linear-gradient(135deg, #fa709a 0%, #fee140 100%)",
  gradientGold: "linear-gradient(135deg, #ffeaa7 0%, #fab1a0 100%)",
  gradientPurple: "linear-gradient(135deg, #a8edea 0%, #fed6e3 100%)",
  
  // THEMED COLORS FOR RESCUE PLATFORM
  urgentRed: "#FF3B5C", // Blinking urgent status
  hopeGreen: "#2ECC71", // Progress/success
  pledgeBlue: "#3498DB", // Pledge buttons
  shareOrange: "#F39C12", // Share buttons
  rescueGold: "#F1C40F", // Rescue achievement
  
  // GLASSMORPHISM EFFECTS
  glassBackground: "rgba(255, 255, 255, 0.05)",
  glassBorder: "rgba(255, 255, 255, 0.1)",
  glassBlur: "blur(10px)",
  
  // SHADOWS FOR DEPTH
  shadowLight: "0 4px 6px rgba(0, 0, 0, 0.3)",
  shadowMedium: "0 8px 25px rgba(0, 0, 0, 0.4)",
  shadowHeavy: "0 20px 40px rgba(0, 0, 0, 0.6)",
  
  // LEGACY COLORS (keeping for compatibility)
  primaryGreen: "#2ECC71",
  black: "#0A0B0F",
  white: "#FFFFFF",
  lightGray: "#B8BCC8",
  lightGray2: "#374151",
  lightGray3: "#4B5563",
  lightGray4: "#6B7280",
  lightGray5: "#1A1D26",
  lightGray6: "#12141A",
  gray: "#9CA3AF",
  blue: "#3498DB",
  red: "#EF4444",
  dodgerBlue: "#1E90FF",
  darkgreen: "#059669",
  darkgray: "#4B5563",
  transparent: "transparent",
  
  // PAWS THEMED - Dark theme versions
  beige: "#2D2A24",
  orange: "#F39C12",
  orangeTwo: "#E67E22",
  orangeThree: "#D35400",
  lightBlue: "#3498DB",
  darkBlue: "#111827",
  yellow: "#F1C40F",
  
  // SPECIAL EFFECTS
  neonGlow: "0 0 20px rgba(59, 130, 246, 0.5)",
  redGlow: "0 0 20px rgba(239, 68, 68, 0.5)",
  greenGlow: "0 0 20px rgba(16, 185, 129, 0.5)",
  pulseAnimation: "pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite",
};

// export default COLORS;
